import { getToken, deleteToken, getUser } from 'Utils/storage';

const baseUrl = process.env.BASE_URL; // new dev  
// const baseUrl = 'https://dev-apis-contracting.transporteg.com';
// const baseUrl = 'https://beta-apis-contracting.transporteg.com';
// const baseUrl = 'https://tms-api-contracting.transporteg.com';
export const adminBaseUrl = process.env.ADMIN_BASE_URL;

export const SSO_BASE_URL = process.env.SSO_BASE_URL;
// export const SSO_BASE_URL = 'https://beta-apis-auth.transporteg.com';
// export const SSO_BASE_URL = 'https://prod-apis-auth.transporteg.com';
export const SSO_URL = '/sso';
export const SSO_USER_VALIDATE = '/sso/validate/';
export const SSO_DELETE_TOKEN = '/sso/logout/';

// ************************** Accounts Base Url ***************************** //
const accountsBaseUrl = process.env.ACCOUNTS_BASE_URL; 
// ************************************************************************** //

// ************************** Accept/Reject LOI ***************************** //
const acceptRejectURL = baseUrl;
// ************************************************************************** //

// **************************** LPP Calculations **************************** //
const LPP_BASE_URL = baseUrl;
// export const LPP_GET_API_URL = '/api/v1/contract-utils/lpp/';
export const LPP_GET_API_URL = '/api/v1/read/lpp/';
// ************************************************************************** //

// **************************** LPP Calculations **************************** //
const CP_LPP_BASE_URL = process.env.CP_LPP_BASE_URL;
// export const LPP_GET_API_URL = '/api/v1/contract-utils/lpp/';
// ************************************************************************** //

export const SEEKER_ACCOUNTS_URL = process.env.SEEKER_ACCOUNTS_URL; // Dev 
export const PROVIDER_ACCOUNTS_URL = process.env.PROVIDER_ACCOUNTS_URL;
// export const ACCOUNTS_URL = 'http://192.168.11.151:7001'; // Nehal Local 

export const SEEKER_INDENT_URL = process.env.SEEKER_INDENT_URL;
export const PROVIDER_INDENT_URL = process.env.PROVIDER_INDENT_URL;
export const INDENTING_BASE_URL = process.env.INDENTING_BASE_URL;

// **************************** File Upload API ***************************** //
const FILE_UPLOAD_BASE_URL = process.env.FILE_UPLOAD_BASE_URL;
export const FILE_UPLOAD_POST_API_URL = '/api/0.1/write/rfq/template';
// ************************************************************************** //

export const LCL_BASE_URL = process.env.LCL_BASE_URL;
export const LCL_URL = process.env.LCL_URL;
export const GOOGLE_API_KEY = process.env.GOOGLE_API_KEY;
export const SAAS_AUTH_URL = process.env.SAAS_AUTH_URL;

// export const SIGN_IN_URL = '/api/0.1/write/company/login';
export const SIGN_IN_URL = '/auth/login/';
// export const FORGOT_PASSWORD_URL = '/api/0.1/write/forgot/password';
export const FORGOT_PASSWORD_URL = '/auth/forgot-password/';

// export const RESET_PASSWORD_URL = '/api/0.1/write/resetpassword';
export const RESET_PASSWORD_URL = '/auth/reset-password/';
export const CHANGE_PASSWORD_URL = '/auth/change-password/';

export const GROUPS_AND_TRANSPORTERS_URL = '/api/0.1/read/transporters';
export const TRANSPORTERS_URL = '/api/0.1/read/fetch/transportermapping';
export const VEHICLE_TYPES_URL = '/api/0.1/read/vehicle/types';
export const VEHICLE_BODY_TYPES_URL = '/api/0.1/read/vehicle/body/types';
export const PACKING_TYPES_URL = '/api/0.1/read/packing/types';
export const BUSINESS_VOLUME_URL = '/api/0.1/read/business/volume';
export const SLABS_URL = '/api/0.1/read/slabs';
export const PAYMENT_CYCLES_URL = '/api/0.1/read/payment/cycle';
export const PRICING_BASIS_URL = '/api/0.1/read/pricing/basis';
export const PRODUCT_CATEGORY_URL = '/api/0.1/read/product/category';

export const CREATE_RFQ_URL = '/api/0.1/write/create/rfq';

export const COPY_RFQ_URL = '/api/0.1/write/copy/rfq';

export const DISCARD_RFQ_URL = '/api/0.1/write/discard/rfq';

export const GET_TRIPS_URL = '/api/0.1/read/fetch/trips';

export const GET_TRIPS_TRANSPORTER_URL = '/api/0.1/read/provider/fetch/trips';

export const GET_QBR_URL = '/api/0.1/read/rfq/qbr';

export const ADD_TRIP_URL = '/api/0.1/write/add/trips';

export const DELETE_TRIP_URL = '/api/0.1/write/delete/trip';

export const GET_RFQS_URL = '/api/0.1/read/fetch/rfqs';

export const GET_RFQS_CONTRACT_URL = '/api/0.1/read/fetch/all/rfqs/contract/records';

export const GET_RFQS_CONTRACT_DETAILS_URL = '/api/0.1/read/fetch/contract/records/rfq';

export const DOWNLOAD_LOI_PDF_URL = '/api/0.1/read/transporter/loi/pdf';

export const RFQ_DETAIL_URL = '/api/0.1/read/fetch/rfq/id';

export const RFQ_DETAIL_TRANSPORTER_URL = '/api/0.1/read/provider/fetch/rfq/id';

export const UPLOAD_DOCUMENT = '/api/0.1/write/file/upload';

export const GET_RFQS_TRANSPORTER_URL = '/api/0.1/read/provider/fetch/contracts';

export const POST_BID_URL = '/api/0.1/write/provider/post/bid';

export const FETCH_BIDS_URL = '/api/0.1/write/provider/fetch/bids';

export const SEEKER_BIDS_URL = '/api/0.1/read/seeker/rfq/bids';

export const CHALLENGE_PRICE_URL = '/api/0.1/write/challenge/price';

export const CP_FORM_MEGA_SAVE_URL = '/api/0.1/write/challengeprice';

export const SEEKER_TRANSPORTERS_LIST_URL = '/api/0.1/read/seeker/rfq/transporters';

export const SEEKER_TRANSPORTER_BIDS_URL = '/api/0.1/read/seeker/rfq/bids/all';

export const SEND_LOI_URL = '/api/0.1/write/send/loi';

export const COUNTER_PRICE_URL = '/api/0.1/write/counter/offer';

export const COUNTER_SEEKER_URL = '/api/0.1/write/seeker/counter/offer';

export const ACCEPT_REJECT_LOI_URL = '/api/0.1/write/accept/reject/loi';

export const ACCEPT_REJECT_CP_URL = '/api/0.1/write/accept/reject/cp';

export const CHANGE_BID_END_URL = '/api/0.1/write/bid/time';

export const CHANGE_TRIP_BID_END_URL = '/api/0.1/write/bid/triptime';

export const BID_EXTENSION_APPROVAL_URL = '/api/0.1/write/rfq/bid/extension/approval';

export const GET_CHAT_MESSAGES_URL = '/api/0.1/read/fetch/chat';

export const SEND_CHAT_MESSAGES_URL = '/api/0.1/write/send/message';

export const DOWNLOAD_RFQ_TEMPALTE_URL = '/api/0.1/read/rfq/template';
export const UPLOAD_RFQ_URL = '/api/0.1/write/rfq/template';

export const DOWNLOAD_BIDDING_DETAILS_URL = '/api/0.1/read/rfq/template';
export const UPLOAD_BIDDING_DETAILS_URL = '/api/0.1/write/rfq/template';

export const DOWNLOAD_BIDDING_DETAILS_TRANSPORTER_URL = '/api/0.1/read/rfq/data';
export const UPLOAD_BIDDING_DETAILS_TRANSPORTER_URL = '/api/0.1/write/rfq/data';

export const DOWNLOAD_TRIPS_TEMPLATE_URL = '/api/0.1/read/rfq/template';
export const UPLOAD_TRIPS_URL = '/api/0.1/write/rfq/template';

export const GET_TRANSPORTERS_URL = '/api/0.1/read/fetch/transportermapping';
export const GET_GROUPS_URL = '/api/0.1/read/fetch/transportation/club';

export const CREATE_GROUP_URL = '/api/0.1/write/create/transportation/club';
export const EDIT_GROUP_URL = '/api/0.1/write/create/transportation/club';
export const DELETE_GROUP_URL = '/api/0.1/write/create/transportation/club';

export const CHALLENGE_PRICE_FORM_URL = '/api/0.1/write/trip';

export const GET_CITY_MAPPING_URL = '/api/0.1/read/city/mapping';
export const ADD_CITY_MAPPING_URL = '/api/0.1/write/city/mapping';
export const UPDATE_CITY_MAPPING_URL = '/api/0.1/write/city/mapping';
export const DELETE_CITY_MAPPING_URL = '/api/0.1/write/city/mapping';

export const HOLISTICS_URL = '/api/0.1/read/holistics/token';

export const RIL_HOLISTICS_URL = '/api/0.1/read/holistics/token/monthlyReport';

export const MARKET_ANALYSIS_URL = '/api/0.1/read/holistics/token/marketAnalysisReport';

export const ALLOCATIONS_URL = '/api/0.1/read/holistics/token/allocationReport';

export const GET_BRANCHES_URL = '/api/0.1/read/branches';

export const GET_USER_BRANCHES_URL = '/api/0.1/read/user/branches';

export const SEND_SFTP_URL = '/api/0.1/write/rfq/sftp';

export const GET_LOCATIONS_URL = '/api/0.1/read/fromtolocations/rfq';

export const UPLOAD_CP_FORM_DATA_URL = '/api/0.1/write/rfq/template';

export const DOWNLOAD_CP_FORM_DATA_URL = '/api/0.1/read/rfq/template';

export const AUTO_SUGGEST_LOCATIONS_URL = '/api/0.1/read/fromToLocations';

export const CP_LPP_URL = '/api/0.1/read/fetchlpp';

export const CANCEL_RFQ_URL = '/api/0.1/write/cancel/rfq';

export const FORGOT_PASSWORD_DETAILS_URL = '/api/0.1/write/updatepassword';

export const GET_ALL_SUBPLANTS_URL = '/api/0.1/read/fetch/subplants';

export const GET_ALL_END_TO_END_URL = '/api/0.1/read/holistics/token/endToend';

export const EDIT_CONTRACT_TO_DATE_URL = '/api/0.1/write/edit/contracttenure';

export const INDENT_MIS_URL = '/api/0.1/read/holistics/token/indentReport';

export const ADD_LOI_APPROVER_URL = '/api/0.1/write/rfq/loisendapprover';

export const SEND_APPROVER_LOI_MESSAGE_URL = '/api/0.1/write/send/message/touser';

export const GET_NETWORK_URL = '/api/0.1/read/contract/network';

export const GET_TRANSPORTER_PARTICIPATION_URL = '/api/0.1/read/holistics/token/transporterPerformance';

export const GET_ALL_VOLTAS_MIS_URL = '/api/0.1/read/holistics/token/voltasMis';

export const EDIT_TK11_CONTRACT_DATA_URL = '/api/0.1/write/resendcontractdata';

export const DELETE_TRIP_DETAILS_URL = '/api/0.1/write/delete/trip/details';

export const CHANGE_TRIP_BASE_VOLUME_URL = '/api/0.1/write/basevolume/trip';

export const GET_ROUTE_CODE_URL = '/api/0.1/read/fetchSapRouteCode';

export const SAVE_ROUTE_CODE_URL = '/api/0.1/write/addSapRouteCode';

export const EDIT_HEADING_CHARGES_URL = '/api/0.1/write/update/multi/mode/cost';

export const GET_SERVER_TIME_URL = '/api/0.1/read/fetch/current/system/time';

export const ADDED_TRIP_DELETE_URL = '/api/0.1/write/delete/trips/details';

export const GET_SECONDARY_TO_LOCATION_URL = '/api/0.1/read/fetchLocation/type';

export const POST_OTHER_COST_CP_URL = '/api/0.1/write/other/cost/challenge/price';

export const OTHER_COST_ACCEPT_REJECT_CP_URL = '/api/0.1/write/accept/reject/other/cost/cp';

export const SECONDARY_UPTO_KM_LIST_URL = '/api/0.1/read/fetchrange/list';

export const GET_MULTI_MODAL_REPORT_URL = '/api/0.1/read/holistics/token/multimodalmis';

export const DOWNLOAD_BIDDING_SEEKER_TRAIL_URL = '/api/0.1/read/bid/seeker/history/template';

export const DOWNLOAD_BIDDING_PROVIDER_TRAIL_URL = '/api/0.1/read/provider/bid/history/template';

export const TK11_EFFICIENCY_DASHBOARD_URL = '/api/0.1/read/holistics/token/tkefficiency';

export const FETCH_SEEKER_BIDS_URL = '/api/0.1/write/seeker/fetch/bids';

export const GET_MOVEMENTS_URL = '/api/0.1/read/fetchmovement/list';

export const GET_MODES_URL = '/api/0.1/read/fetchmode/list';

export const GET_ZONES_URL = '/api/0.1/read/fetchzone/list';

export const GET_COURIER_SLAB_URL = '/api/0.1/read/fetchslab/list';

export const GET_COURIER_TRIPS_URL = '/api/0.1/read/fetch/courier';

export const POST_COURIER_TRIPS_URL = '/api/0.1/write/add/courier';

export const DOWNLOAD_COURIER_TRIPS_TEMPLATE_URL = '/api/0.1/read/courier/download/template';

export const UPLOAD_COURIER_TRIPS_URL = '/api/0.1/write/courier/upload/template';

export const COURIER_POST_BID_URL = '/api/0.1/write/provider/courier/post/bid';

export const DOWNLOAD_COURIER_BIDDING_PROVIDER_URL = '/api/0.1/read/provider/courier/template';

export const UPLOAD_COURIER_BIDDING_PROVIDER_URL ='/api/0.1/write/upload/courier/bid';   

export const PROVIDER_DOWNLOAD_SERVICE_CATEGORY_TEMPLATE_URL = '/api/0.1/read/provider/service/category/template';

export const PROVIDER_UPLOAD_SERVICE_CATEGORY_TEMPLATE_URL = '/api/0.1/write/provider/upload/service/category';

export const GET_SERVICE_CATEGORY_URL = '/api/0.1/read/provider/service/availability';

export const POST_SERVICE_CATEGORY_URL = '/api/0.1/write/update/provider/service/availability';

export const GET_TRANSPORTER_BID_COMMON_CHARGES_URL = '/api/0.1/read/courier/common/charges';

export const GET_IP_ADDRESS_URL = 'https://api.ipify.org/?format=json';

export const CLEAR_MESSAGE_URL = '/api/0.1/write/clear/message';

export const  DOWNLOAD_MULTIMODE_TRIPS_TEMPLATE_URL ='/api/0.1/read/multimode/add/trip/template';

export const UPLOAD_MULTIMODE_TRIPS_TEMPLATE_URL = '/api/0.1/write/multimode/trip/upload/template';

export const WEB_NOTIFICATION_URL = '/api/0.1/fetch/dataForNotif';

export const LEGRAND_SUMMARY_REPORT_URL = '/api/0.1/read/holistics/token/summaryreport';

export const LEGRAND_PLANT_WISE_REPORT_URL = '/api/0.1/read/holistics/token/plantwisereport';

export const CURRENCY_DETAILS_URL = '/api/0.1/read/currency/details';

export const SEEKER_CURRENCY_DETAILS_URL = '/api/0.1/read/seeker/currency/details';

export const DOWNLOAD_MULTI_MODE_BID_DETAILS_TRANSPORTER_URL ='/api/0.1/read/download/multimode/bid/template';

export const UPLOAD_MULTI_MODE_BID_TRANSPORTER_URL ='/api/0.1/write/upload/multimode/bid';

export const SEEKER_RFQ_TYPES_URL = '/api/0.1/read/seeker/rfq/types';

export const PROVIDER_RFQ_TYPES_URL = '/api/0.1/read/provide/rfq/types';

export const SYSTEM_SUGGESTED_PRICE_URL = '/api/0.1/read/get/ssp';

export const REPORT_TEMPLATE_DOWNLOAD_URL = '/api/v1/downloads/generic/format/';

export const MARKET_RATE_REPORTS_URL = '/api/v1/analytics/mis_token/';

export const DOWNLOAD_AUDIT_TRAIL_FORM_DATA_URL='/api/0.1/read/challenge/price/audit/trail/template';

export const ANALYTICS_LOCATIONS_URL = '/api/v1/analytics/locations/';

export const CHECK_CONTRACT_EXIST_URL = '/api/0.1/read/existing/contract';

export const YARD_TO_YARD_BCN_VALUES_URL = '/api/0.1/read/fois/rake/route';

export const FREIGHT_CALCULATATION_URL = '/api/0.1/read/fois/details';

export const GET_OTHERS_LPP_URL = '/api/0.1/read/other/lpp';

export const AMMENDMENT_LIST_URL = '/contracts/fetch/ammendmentdata';

export const AMMENDMENT_APPROVE_URL = '/contracts/approve/contractammendment';

export const DOWNLOAD_MARKET_SITE_RATE_DIFF_URL='/api/0.1/read/market/site/diff/template';
export const DOWNLOAD_BID_RATE_TEMPLATE_URL = '/api/0.1/read/rfq/rates/template';

export const UPLOAD_BID_RATE_URL ='/api/0.1/write/rfq/rate/template';

export const DOWNLOAD_TRUCKS_DETAILS_TEMPLATE_URL = '/api/0.1/read/trip/trucks/details/template';

export const UPLOAD_TRUCKS_DETAILS_URL ='/api/0.1/write/trip/number/trucks/template';

export const NUMBER_OF_VEHICLE_PLACED_URL = '/api/0.1/write/updated/number/of/vehicle';

export const EXISITING_CONTRACT_DETAILS_URL = '/api/0.1/read/existing/contract/details';

export const GENERATE_CONTRACT_URL = '/api/0.1/write/rfq/generate/contract';

export const UPLOAD_MULTIMODE_EXISITING_CONTRACT_URL = '/api/0.1/write/generate/contract/template';

export const DOWNLOAD_MULTIMODE_EXISITING_CONTRACT_URL = '/api/0.1/read/generate/contract/template';

export const GENERATED_CONTRACTS_LIST_URL = '/api/0.1/read/generate/contract/rfq';

export const GET_CONTAINER_LIST_URL = '/api/0.1/read/fetch/container/list';

export const GET_RAKE_LIST_URL = '/api/0.1/read/fetch/rake/list';

export const GET_DEPOT_LIST_URL = '/api/0.1/read/fetch/dept/list';

export const GET_PLANT_LIST_URL = '/api/0.1/read/fetch/plant/list';

export const GET_CHA_DETAILS_URL = '/api/0.1/read/list/cha';

export const FREIGHT_AGAINST_VEHICLE_REPORTS_URL = '/api/0.1/read/holistics/token/freightdetailsvehicle';

export const CURRENCY_TYPES_URL = '/api/0.1/read/currency/type';

export const  VENDOR_WITH_DRAW_URL = '/api/0.1/write/vendor/withdraw/bid';

export const REVOKE_WITHDRAW_BID_URL = '/api/0.1/read/revoke/bid/withdrawn';

// export const LOG_OUT_URL = '/api/0.1/write/logout';
export const LOG_OUT_URL = '/auth/logout/';

export const CLOSED_RFQ_URL = '/api/0.1/write/closed/rfq';

export const ACCEPTANCE_OF_CEILING_PRICE_URL='/api/0.1/write/acceptance/ceiling/price';

export const CANCELLED_LOI_URL ='/api/0.1/write/loi/cancelled';

export const STATUS_GROUP_URL = '/api/0.1/write/transporters/status';

export const GET_UPLOAD_PLAN_URL = '/api/0.1/read/uploadplan';

export const POST_UPLOAD_PLAN_URL = '/api/0.1/write/uploadplan';

export const UPDATE_UPLOAD_PLAN_URL = '/api/0.1/update/uploadplan';

export const DELETE_UPLOAD_PLAN_URL = '/api/0.1/delete/uploadplan';

export const GET_LOCATION_NETWORK_URL = '/api/0.1/read/location/network';

export const FILE_UPLOAD_PLAN_URL = '/api/0.1/upload/uploadplan';

export const DOWNLOAD_UPLOADPLAN_TEMPLATE_URL = '/api/0.1/download/uploadplan';

export const CONTRACTING_SHORT_MIS_URL = '/api/0.1/read/mis/short';

export const DOWNLOAD_AWL_MULTIMODE_TEMPLATE_URL = '/api/0.1/read/rfq/multimode/trip/template';

export const UPLOAD_AWL_MULTIMODE_EXCEL_URL = '/api/0.1/write/Legtype/multimode/trip/upload/template';

export const GET_LOCATION_WITH_PINCODE_URL = '/api/0.1/read/list/pincode';

export const GET_GOOGLE_STUDIO_REPORT_URL = '/api/0.1/read/iframe';

export const GET_HOLISTICS_TOKEN_MIS_URL = '/api/0.1/read/holistics/token/mis';

export const GET_INCOTERMS_LIST_URL = '/api/0.1/read/inco/term/code';

export const GET_COST_HEADS_URL = '/api/0.1/read/cost/head';

export const AIR_SHIPMENT_TRACKING_URL = '/api/0.1/read/air/cargo/details';

export const CONTAINER_SHIPMENT_TRACKING_URL = '/api/0.1/read/container/tracking/details';

export const DIESEL_PRICE_HIKE_URL = '/api/0.1/read/fetch/diesel/price';

export const SEC_AWL_ADD_TRIP_URL = '/api/0.1/write/add/dedicated/slab/trips';

export const GET_FUEL_TYPES_URL = '/api/0.1/read/fuel/types';

export const VEHICLE_TYPES_NEW_URL = '/api/0.1/read/plant/wise/vehicle/types';

export const PACKING_TYPES_NEW_URL = '/api/0.1/read/plant/wise/packing/types';

export const VEHICLE_BODY_TYPES_NEW_URL = '/api/0.1/read/plant/wise/vehicle/body';

export const PAYMENT_CYCLES_NEW_URL = '/api/0.1/read/plant/wise/payment/cycle';

export const BUSINESS_VOLUME_NEW_URL = '/api/0.1/read/plant/wise/business/volume';

export const PRICING_BASIS_NEW_URL = '/api/0.1/read/plant/wise/pricing/basis';

export const PRODUCT_CATEGORY_NEW_URL = '/api/0.1/read/plant/wise/product/category';

export const GET_PAYMENT_TERMS_NEW_URL = '/api/0.1/read/plant/wise/payment/terms';

// export const REQUEST_OTP_URL = '/api/0.1/write/get/otp';

export const REQUEST_OTP_URL = '/auth/send-otp/';

// export const OTP_SIGNIN_URL = '/api/0.1/write/login/by/otp';

export const OTP_SIGNIN_URL = '/auth/verify-otp/';

export const SSO_LOGIN_RESPONSE_URL = '/sso/get-session';
export const GET_TEG_USER_DATA_URL = '/auth/get-user-data/';

export const AWL_CONTRACTING_MIS_URL = '/api/0.1/read/holistics/token/contractMis';

export const SSO_CONFIG_URL = '/sso/get-sso-config';

export const DPL_CONTRACTING_INDENTING_MIS_URL = '/api/0.1/read/holistics/token/contractIndentReport';

export const GET_BROADCAST_MSG_URL = '/broadcast/get-messages';

export const GET_DISPOSAL_MATERIAL_TEMPLATE_URL = '/api/0.1/read/disposal/msp/template';

export const UPLOAD_DISPOSAL_MATERILA_URL = '/api/0.1/write/disposal/msp/template';

export const GET_DISPOSAL_MATERIAL_TRIPS_URL = '/api/0.1/read/fetch/product/disposal/material/trips';

export const POST_DISPOSAL_MATERIAL_TRIPS_URL = '/api/0.1/write/add/product/disposal/material/code/trips';

export const POST_DISPOSAL_PRODUCT_BID_URL = '/api/0.1/write/provider/post/disposal/bid';

export const TRANSPORTER_CONTRACT_RECORDS_URL = '/api/0.1/read/transporter/contract/records';

export const TRANSPORTER_SPECIFIC_CONTRACT_RECORD_URL = '/api/0.1/read/transporter/contract/records/id';

// export const GET_SPOT_CONTRACT_REASON_URL = '/api/0.1/read/contract/reasons';
export const GET_SPOT_CONTRACT_REASON_URL = '/api/0.1/read/dropdown/othercharges';

export const GET_TRANSPORTERS_REPORT_URL = '/api/0.1/read/holistics/token/transporterReport';

export const BL_SHIPMENT_TRACKING_URL = '/api/0.1/read/bl/tracking/details';

export const GET_SEA_AND_AIR_LINES_URL = '/api/0.1/read/sea/air/list';

export const GET_ROUTE_MASTER_URL = '/api/0.1/read/fetch/all/master/code';

export const ADD_ROUTE_MASTER_URL = '/api/0.1/write/add/master/code';

export const UPDATE_ROUTE_MASTER_URL = '/api/0.1/write/update/master/code';

export const DELETE_ROUTE_MASTER_URL = '/api/0.1/delete/master/code';

export const DOWNLOAD_ROUTE_MASTER_TEMPLATE_URL = '/api/0.1/download/master/code/template';

export const DOWNLOAD_ROUTE_MASTER_DETAILS_URL = '/api/0.1/download/master/code/template/details';

export const UPLOAD_ROUTE_MASTER_DETAILS_URL = '/api/0.1/write/upload/master/code/template';

export const CHECK_FTL_CONTRACT_EXIST_URL = '/api/0.1/read/ftl/existing/contract';

export const SHARE_OF_BUSINESS_URL = '/api/0.1/write/share/percentage';

export const GET_CONTRACT_TENURE_LIST_URL = '/api/0.1/read/fetch/master/contract/tenure';

export const UPDATE_DPH_URL = '/api/0.1/write/dph/percentage';
export const UPDATE_DPH_CALCULATION_MASTER_URL = '/api/0.1/update/dph/calculation/master';
export const DOWNLOAD_DPH_CALCULATION_MASTER_URL = '/api/0.1/download/dph/calculation/master';
export const UPLOAD_DPH_CALCULATION_MASTER_URL = '/api/0.1/upload/dph/calculation/master';

export const EXTEND_TRIP_LEVEL_CONTRACT_TENURE_URL = '/api/0.1/read/extend/contract/tenure';

export const TRIP_LEVEL_BID_TIME_EXTENSION_URL = '/api/0.1/write/trip/level/bid/time';

export const GET_SAP_ROUTE_CODES_URL = '/api/0.1/read/fetchAllSapRouteCode';
export const REJECT_LOI_FROM_APPROVER_URL =  '/api/0.1/write/reject/loi/approver';

// export const DOWNLOAD_EXIST_CONTRACT_TEMPLATE_URL = '/api/0.1/read/existing/contract/template';
export const DOWNLOAD_EXIST_CONTRACT_TEMPLATE_URL = '/api/0.1/download/offline/contract';

// export const UPLOAD_EXIST_CONTRACT_URL = '/api/0.1/write/existing/contract/template';
export const UPLOAD_EXIST_CONTRACT_URL = '/api/0.1/upload/offline/contract';
export const UPLOAD_FILE_IN_CONTRACT_RECORDS_RFQ_URL = '/api/0.1/write/contract/records/file/upload';
export const CREATE_INDENTS_URL = '/api/0.1/write/create/existing/contract/indents';

export const DELETE_UPLOADED_FILE_URL = '/api/0.1/write/delete/existing/contract/file';

export const POST_DPH_APPROVER_URL = '/api/0.1/write/rfq/dph/send/approver';
export const POST_DPH_APPROVAL_URL = '/api/0.1/write/send/dph';

export const RETRIGGER_TK11_FOR_RFQ_URL = '/api/0.1/write/retriggerTK11ForRFQ';

//Event Management api's
export const GET_EVENT_DETAILS_URL = '/api/0.1/get/event/details';
export const DELETE_EVENT_DETAIL_URL = '/api/0.1/delete/event/details';
export const DOWNLOAD_EVENT_DETAIL_TEMPLATE_URL = '/api/0.1/download/rfq/event/template';
export const UPLOAD_EVENT_DETAILS_URL = '/api/0.1/upload/rfq/event/template';
export const CREATE_EVENT_URL = '/api/0.1/write/create/event';
export const GET_PARTICULAR_EVENT_DETAILS_URL = '/api/0.1/read/rfq/event';
export const GET_RFQ_EVENT_URL = '/api/0.1/read/rfq/event';
export const CANCEL_EVENT_URL = '/api/0.1/write/cancel/event';
export const UPLOAD_RFQS_FOR_EVENT_URL = '/api/0.1/upload/rfq/event/template';
export const SCHEDULE_EVENT_URL = '/api/0.1/write/schedule/event';
export const GET_EVENT_STATUS_URL = '/api/0.1/get/rfq/status/by/event/id';
export const GET_EVENT_RFQ_DETAILS_URL = '/api/0.1/get/event/rfq/details/rfqid';
export const UPDATE_EVENT_RFQ_URL = '/api/0.1/write/update/event/rfq';
export const UPDATE_EVENT_RFQ_TRIPS_URL = '/api/0.1/write/update/event/trip';
export const GET_SOB_TEMPLATE_URL = '/api/0.1/read/sob/template';
export const POST_SOB_TEMPLATE_URL = '/api/0.1/write/sob/template';
export const GET_WINNING_TRANSPORTERS_URL = '/api/0.1/read/winning/transporters/volume';
export const DELETE_WINNING_TRANSPORTER_URL = '/api/0.1/write/delete/volume/winning/transporter';
export const POST_WISHLIST_URL = '/api/0.1/write/event/wishlist/rfq';
export const FTL_CONTRACT_TYPE_URL = '/api/0.1/read/contract/ftl/type';

export const GET_OFFLINE_SLABWISE_TRIPS_TEMPLATE_URL = '/api/0.1/download/offline/trips';
export const POST_UPLOAD_OFFLINE_SLABWISE_TRIPS_URL = '/api/0.1/upload/offline/trips';

export const GET_PROVIDER_SIDE_CHAT_MESSAGES_URL = '/api/0.1/read/provider/fetch/chat';
export const SEND_PROVIDER_SIDE_CHAT_MESSAGES_URL = '/api/0.1/write/provider/send/message';

export const GET_ALL_MASTER_CONTRACTS_URL = '/api/0.1/fetch/allmastercontracts';
export const GET_FROM_ROUTE_LIST_URL = '/api/0.1/fetch/multimodal/saproutedata';
export const GET_BRANCH_YARD_URL = '/api/0.1/fetch/dropdown/branchyard';
export const POST_SEARCH_ROUTE_MASTER_URL = '/api/0.1/write/searchroute/mastercontract';

export const GET_YARD_URL = '/api/0.1/fetch/dropdown/branchyard';
export const GET_GENERATE_ROUTE_CODES_URL = '/api/0.1/fetch/multimodalroutes';
export const ADD_ADDITIONAL_TRANSPORTERS_DURING_BIDDING_URL = '/api/0.1/write/addition/transporter/during/bidding';
export const GET_TRANSPORTER_REVISED_PRICE_DETAILS_URL = '/api/0.1/read/transporter/revised/price/id';
export const GET_TRANSPORTER_WISE_REVISED_PRICE_URL = '/api/0.1/read/transporter/wise/revised/price/id'; 
export const GET_RFQ_LEVEL_REVISED_PRICE_DETAILS_URL = '/api/0.1/read/all/transporter/revised/price/id';
export const DOWNLOAD_REVISED_PRICE_DETAILS_URL = '/api/0.1/download/revised/price/details';
export const GET_CLUSTER_DETAILS_URL = '/api/0.1/read/cluster/code';
export const GENERATE_PLAN_IN_MASTER_CONTRACT_URL = '/api/0.1/write/createmastercontract';

export const GET_CONTRACT_DETAILS_URL = '/api/0.1/fetch/mastercontractdetails';

export const GET_CHILD_CONTRACT_TK11_URL = '/api/0.1/fetch/childcontracttk11data';

export const GET_MASTER_CONTRACT_TK11_URL = '/api/0.1/fetch/mmcontracttk11data';
export const GET_ZONE_WISE_URL = '/api/0.1/read/zone/name';
export const GET_COMPANY_BRANCH_LIST_URL = '/api/0.1/read/branch/by/id';
export const GET_VENDOR_BIDDING_STATUS_URL = '/api/0.1/read/vendor/bidding/status';
export const UPDATE_RFQ_LEVEL_VENDOR_BIDDING_STATUS_URL = '/api/0.1/write/vendor/bidding/status';
export const GET_OTHER_CHARGES_TEMPLATE_URL = '/api/0.1/read/other/charges/template';
export const UPLOAD_OTHER_CHARGES_URL = '/api/0.1/write/other/charges/template';
export const UPDATE_POST_BID_TO_PRE_BID_RFQ_URL = '/api/0.1/write/update/post/bid/rfq';
export const DOWNLOAD_TRANSPORTER_WISE_BID_DETAILS_URL = '/api/0.1/read/contract/record/transporter/wise/by/id';
export const GET_SECONDARY_CONTRACTS_URL = '/api/0.1/read/all/secondary/contract/data';
export const GET_VENDOR_LIST_URL = '/api/0.1/read/company-vendors/details';

export const RETRIGGER_MASTER_CONTRACT_TK11_URL = '/api/0.1/write/retriggermastercontracttk11'

export const SAVE_RETRIGGER_MC_TK11_URL = '/api/0.1/write/saveretriggerdatamctk11'

export const GET_LOCATION_DROPDOWN_VALUES_URL = '/api/0.1/fetch/dropdownLocationFromRoutes';
export const GET_MASTER_ROUTE_CODE_URL = '/api/0.1/read/master/route/code';

export const DOWNLOAD_SECONDARY_CONTRACTS_TEMPLATE_URL = '/api/0.1/read/secondary/contract/template';
export const UPLOAD_SECONDARY_CONTRACTS_TRIPS_URL = '/api/0.1/write/secondary/contract/template';
export const POST_SECONDARY_CONTRACTS_URL = '/api/0.1/write/secondary/contract/rfq';
export const DELETE_SECONDARY_CONTRACT_RFQ_URL = '/api/0.1/write/secondary/contract/rfq/id';
export const GET_SECONDARY_CONTRACT_BY_RFQID_URL = '/api/0.1/read/secondary/contract/rfq/id';
export const GET_SECONDARY_CONTRACT_CFA_DETAILS_URL = '/api/0.1/read/secondary/contract/cfa';
export const UPDATE_SECONDARY_CONTRACTS_URL = '/api/0.1/write/update/secondary/contract/trip';

export const DOWNLOAD_TEMPLATE_MULTI_CONTRACT_URL = '/api/0.1/read/multi/contract/template';
export const UPLOAD_MULTI_CONTRACT_URL = '/api/0.1/write/multi/contract/template';
export const GET_MULTI_CONTRACT_DATA_URL = '/api/0.1/read/multi/contract/data';
export const DELETE_MULTI_CONTRACT_URL = '/api/0.1/write/multi/contract';
export const GET_MULTI_CONTRACT_TYPES_URL = '/api/0.1/read/multi/contract/types';
export const UPDATE_MULTI_CONTRACT_URL = '/api/0.1/write/update/multi/contract';
export const MULTI_CONTRACT_SEND_LOI_FOR_APPROVAL_URL = '/api/0.1/write/contract/send/approver';
export const GET_TRIP_TYPES_URL = '/api/0.1/read/multi/trip/types';


export const DOWNLOAD_EXTISTING_TRIPS_REMARKS_TEMPLATE_URL = '/api/0.1/read/existing/trip/remarks/template';
export const UPLOAD_EXTISTING_TRIPS_REMARKS_URL = '/api/0.1/write/existing/trip/remarks/upload';

export const GET_MULTI_MODE_ROUTE_CODE_URL = '/api/0.1/read/master/multi/mode/route/code';
export const GET_CONTAINER_TYPES_URL = '/api/0.1/read/master/container/trip/type';
export const GET_CONTAINER_TYPES_LIST_URL = '/api/0.1/read/master/container/type';
export const DOWNLOAD_CONTAINER_TEMPLATE_URL = '/api/0.1/read/container/contract/template';
export const UPLOAD_CONTAINER_TRIPS_URL = '/api/0.1/write/container/contract/upload';
export const GET_CONTAINER_TRIPS_URL = '/api/0.1/read/fetch/container/trips';
export const POST_CONTAINER_TRIPS_URL = '/api/0.1/write/add/container/trips';
export const POST_CONTAINER_LPP_URL = '/api/0.1/write/container/lpp';

export const DOWNLOAD_FILE_URL = '/api/0.1/read/presigned/url';
export const GET_OFFLINE_CONTRACTS_DETAILS_TO_UPDATE_URL = '/api/0.1/read/offline/contract/trips';
export const POST_OFFLINE_CONTRACTS_DETAILS_UPDATED_DETAILS_URL = '/api/0.1/write/offline/transporter/bids';

export const POST_ACCEPT_CEILING_PRICE_LOI_URL ="/api/0.1/read/accept/ceiling/price/my/bid"; 
export const POST_TRIP_FILE_REMARKS_URL ="/api/0.1/write/trip/file/remarks";
export const GET_REGION_NAMES_URL ="/api/0.1/read/region/names";
// Multimodal rate comparison end point start here

export const GET_MULTIMODE_RATE_COMPARISON_SOURE_DESTINATION_LIST_URL = '/api/0.1/read/multimode/rate/comparison/soure/destination';
export const GET_MULTIMODE_RATE_COMPARISON_COMMODITY_CATEGORY_LIST_URL = '/api/0.1/read/multimode/rate/comparison/commodity/category';
export const GET_MULTIMODE_RATE_COMPARISON_FREIGHT_RATE_LIST_URL = '/api/0.1/read/multimode/rate/comparison/freight/rate';
export const GET_MULTIMODE_RATE_COMPARISON_FREIGHT_DAYS_LIST_URL = "/api/0.1/read/multimode/rate/comparison/freight/days";
export const GET_MULTIMODE_RATE_COMPARISON_VEHICLE_DETAILS_LIST_URL = "/api/0.1/read/multimode/rate/comparison/vehicle/details";
export const GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_ROAD_FREIGHT_RATE_LIST_URL = '/api/0.1/read/multimode/rate/comparison/road/freight/rate';
export const GET_MULTIMODE_RATE_COMPARISON_VIEW_DETAILS_RAIL_FREIGHT_RATE_LIST_URL = "/api/0.1/read/multimode/rate/comparison/rail/freight/rate";
export const GET_RAIL_RAKE_LIST_URL = "/api/0.1/read/fetch/rail/rake";
export const GET_ORIGIN_DESTINATION_YARD_LIST_URL = "/api/0.1/read/fetch/origin/destination/yard";

// Multimodal rate comparison end point end here

// New exim cargo tracking end point start here

export const GET_EXIM_CARGO_TEMPLATE_URL ="/api/0.1/read/exim/cargo/template";
export const UPLOAD_EXIM_CARGO_TEMPLATE_URL ="/api/0.1/write/exim/cargo/upload";
export const GET_EXIM_CONTAINER_BL_TRACKING_DETAILS_URL ="/api/0.1/read/exim/container/bl/tracking/details";
export const GET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS_URL ="/api/0.1/read/exim/cargo/source/destination/port";
export const GET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE_URL = "/api/0.1/read/exim/container/bl/tracking/template";
export const SAVE_EXIM_CONTAINER_ADDITIONAL_FILES_SKU_DETAILS_URL='/api/v1/exim/sku/update';

// New exim cargo tracking end point end here



// Supplier RFQ  end point start here

export const GET_CONSIGNOR_PICKUP_LOCATION_LIST_URL ="/api/0.1/read/consignor/pickup/location";
export const GET_SERVICE_TYPES_LIST_URL ="/api/0.1/read/master/service/types";
export const GET_SERVICE_MODE_TYPES_LIST_URL ="/api/0.1/read/master/service/mode/types";
export const GET_CARGO_DETAILS_TYPES_LIST_URL ="/api/0.1/read/master/cargo/details/types";
export const GET_CARGO_MATERIAL_PACKING_TEMAPLATE_URL ="/api/0.1/read/cargo/material/packing/temaplate";
export const UPLOAD_CARGO_MATERIAL_PACKING_TEMAPLATE_URL ="/api/0.1/write/cargo/material/packing/template";
export const GET_HANDLING_INSTRUCTION_TYPES_LIST_URL ="/api/0.1/read/master/handling/instruction/types";
export const GET_VEHICLE_TYPES_LIST_URL ="/api/0.1/read/plant/wise/vehicle/types";
export const CREATE_SUPPLIER_CONTRACT_URL ="/api/0.1/write/create/supplier/contract";
export const GET_PACKING_TYPES_LIST_URL ="/api/0.1/read/plant/wise/packing/types";
export const GET_SUPPLIER_NAME_LIST_URL ="/api/0.1/read/supplier/name";
export const CREATE_TRANSPORTATION_RFQ_URL ="/api/0.1/write/create/transportation/rfq";
export const GET_SUPPLIER_DETAILS_RFQ_URL ="/api/0.1/read/supplier/details/id";
export const UPDATE_SUPPLIER_CONTRACT_DETAILS_URL ="/api/0.1/write/update/supplier/contract/details";
export const DELETE_SUPPLIER_CONTRACT_RFQ_DETAILS_URL ="/api/0.1/write/supplier/contract/details";

// Supplier RFQ  end point end here

// Supplier Or TransportationRequestsDashboard end point start here

export const GET_SUPPLIER_TRANSPORTATION_CONTRACTS_DETAILS_URL = "/api/0.1/read/supplier/transportation/contracts/details";
export const DOWNLOAD_SUPPLIER_TRANSPORTATION_CONTRACTS_URL = "/api/0.1/read/supplier/transportation/contracts/download";
export const GET_TRANSPORTER_MAPPING_LIST_URL ="/api/0.1/read/fetch/transportermapping";
export const GET_PROVIDER_MATERIAL_PACKING_DETAILS_URL ="/api/0.1/read/provider/material/packing/details";

// Supplier Or TransportationRequestsDashboard end point end here

export const POST_OVERALL_ALLOCATION_URL = "/api/0.1/write/all/product/allocation";

export const DELETE_SECONDARY_CONTRACT_RFQ_TRIP_URL="/api/0.1/write/secondary/contract/trip/id";
export const SEARCH_SECONDARY_CONTRACT_RFQ_TRIP_URL="/api/0.1/read/search/secondary/contract/trips";
export const GET_SOURCE_ICD_BRANCH_LIST_URL = "/api/0.1/read/icd/branch/name/by/source";
export const GET_ALL_ICD_BRANCH_LIST_URL = "/api/0.1/read/all/icd/branch/names";
export const GET_ICD_DESTINATION_ROUTE_CODE_URL = "/api/0.1/read/icd/destination/route/code";


// FOSROC - Extend the Bid Time for the Single Bided Trips  APIS start here
export const EXTEND_BID_TIME_FOR_SINGLE_BIDDED_TRIPS_URL = "/api/0.1/write/extend/time/without/bid/trip";
// FOSROC - Extend the Bid Time for the Single Bided Trips  APIS ends here

export const GET_CONSIGNEE_DETAILS_BY_NAME_URL = "/api/0.1/read/consignee/details/by/name";
export const SEEKER_COMPANY_LIST_URL = "/api/0.1/read/transporter/access/company/names";

export const EXIM_ON_DEMAND_TRACKING_URL = '/api/0.1/read/ondemand/container/tracking';
export const SECONDARY_CONTRACT_TENURE_VALIDATION_URL = '/api/0.1/write/secondary/contract/tenure/validation';
export const EXIM_ADD_TRIP_URL = '/api/0.1/write/add/exim/trips';
export const GET_EXIM_TRIPS_URL = '/api/0.1/read/fetch/exim/trips';
export const GET_PORT_DETAILS_URL = '/api/0.1/read/port/master/data';
export const EXIM_EDIT_UPDATE_CHARGES_URL = '/api/0.1/write/provider/other/cost/post/bid';
export const EXIM_POST_BID_URL = '/api/0.1/write/provider/exim/post/bid';

export const GET_EXIM_LPP_URL = '/api/0.1/read/fetch/exim/heading/cost/lpp';
export const REACTIVATE_TK11_URL = '/api/0.1/tk11/reactivate';
export const CANCEL_CP_URL = '/api/0.1/challenge/price/cancel';
export const ACCEPT_TERMS_AND_CONDITIONS_URL = '/api/0.1/write/accept/terms';

// Booking Reference URLs
export const BOOKING_REFERENCE_OCR_EXTRACT_URL = '/api/0.1/write/booking/reference/ocr/extract';
export const BOOKING_REFERENCE_UPLOAD_URL = '/api/0.1/write/booking/reference/upload';
export const BOOKING_REFERENCE_LIST_URL = '/api/0.1/read/booking/reference/rfq/liner/list';
export const UPDATE_BOOKING_COPY_URL = '/api/0.1/write/booking/reference/booking/copy';
export const DELETE_BOOKING_OCR_DATA_URL = '/api/0.1/write/booking/reference/ocr/data';
export const MANAGE_BOOKING_BL_URL = '/api/0.1/write/booking/reference/bl/manage';
export const DOWNLOAD_BOOKING_OCR_REPORT_URL = '/api/0.1/read/booking/reference/ocr/report';

export const ocrBookingDocument = (file) => {
   return uploadFile(BOOKING_REFERENCE_OCR_EXTRACT_URL, file).then((res) => res.data);
};

// Desmet PO Creation Start Here

export const FETCH_ALL_PO_URL = '/api/v1/fetch/all/po';
export const CREATE_PO_URL = '/api/v1/create/po';
export const GET_PO_DROPDOWN_LISTS_URL = '/api/v1/po/master';
export const GET_PART_DETAILS_URL = '/api/v1/po/part/details/id';
export const DOWNLOAD_PO_TEMPLATE_URL = '/api/v1/po/download';
export const UPLOAD_PO_URL = '/api/v1/po/upload';
export const GET_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL = '/api/v1/fetch/raw/material/production/status';
export const SAVE_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL = '/api/v1/create/po/raw/production';
export const UPDATE_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL = '/api/v1/po/raw/production/update';
export const GET_PO_HISTORY_URL = '/api/v1/po/history';
export const ACCET_REJECT_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL = '/api/v1/po/accept/reject';
export const CANCEL_PO_URL = '/api/v1/po/cancel';
export const GET_PO_BY_ID_URL = '/api/v1/fetch/po/id';
export const GET_PO_DATA_BY_ID_URL = '/api/v1/fetch/po/id';
export const UPDATE_PO_URL = '/api/v1/po/update';
export const GET_PO_STATUS_COUNT_URL = '/api/v1/fetch/po/count';
export const GET_PO_LIST_URL = '/api/v1/fetch/po/ids';
export const GET_SUPPLIER_ITEM_MASTER_URL = '/api/0.1/read/supplier/item/master';
export const GET_DEV_TOOLS_CONFIG_URL = '/api/0.1/read/devtool';

export const GET_TRIPS_LOGS_URL = '/api/v1/fetch/trips/logs';

export const DELETE_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL = 'api/v1/po/raw/production/delete';

// export const DELETE_RAW_MATERIALS_OR_PRODUCTION_STATUS_URL = 'api/v1/po/raw/production/delete';

// Desmet PO Creation End Here

export const SAVE_USER_REPORT_UTILIZATION_EVENT_URL = '/api/v1/add/user/utilization/report';
export const GET_EXIM_AWL_PLANT_WISE_COST_HEADS_URL = '/api/0.1/read/plant/wise/cost/head/types';

export const GET_PAYMENT_TERMS_URL = '/api/0.1/read/plant/wise/payment/terms';

export const GET_SERVICE_MODE_URL = '/api/0.1/read/plant/wise/service/mode';

export const GET_PROCUREMENT_LPP_URL = '/api/0.1/read/fetch/procurement/lpp';

export const VENDOR_WITH_MATERIAL_CODE_URL = '/api/0.1/read/material/code';

export const GENERAL_PROCUREMENT_ADD_TRIP_URL = '/api/0.1/write/add/material/code/trips';

export const GET_PROCUREMENT_TRIPS_URL = '/api/0.1/read/fetch/procurement/trips';

export const GET_PR_TRACKING_URL = '/api/0.1/read/contract/procurement/tracking';

export const DELETE_CONTRACT_RECORD_URL = '/api/v1/delete/contract/record';

export const DOWNLOAD_MULTIMODAL_OFFLINE_CONTRACT_URL = '/api/v1/download/offline/multimode/child/contract';

export const UPLOAD__MULTIMODAL_OFFLINE_CONTRACT_URL = '/api/v1/upload/offline/multimode/child/contract';

export const SAVE_TRACK_SCREEN_TIMING_URL = '/api/v1/screens/monitoring';

/* Transportation Management Start Here */

export const GET_TRANSPORTATION_MANAGEMENT_URL = '/api/v1/fetch/transportation/management';
export const POST_TRANSPORTATION_MANAGEMENT_URL = '/api/v1/add/transportation/management';
export const UPDATE_TRANSPORTATION_MANAGEMENT_URL = '/api/v1/update/transportation/management';
export const DELETE_TRANSPORTATION_MANAGEMENT_URL = '/api/v1/transportation/management/id';
export const DOWNLOAD_TRANSPORTATION_MANAGEMENT_URL = '/api/v1/download/transportation/management';
export const UPLOAD_TRANSPORTATION_MANAGEMENT_URL = '/api/v1/upload/transportation/management';
export const GET_VEHICLE_REGNUMBER_DETAILS_URL = 'api/v1/fetch/vehicle/regnumber/details';
export const GET_TTBIL_ROUTE_CODE_DETAILS_URL = '/api/v1/fetch/rout/code/details';

export const GET_AUDIT_LOG_DETAILS_URL = '/api/v1/fetch/audit/logs';

export const POST_TOLL_TAX_UPDATE_PRICE_URL = "/api/0.1/write/rfq/toll/price/update";

export const GET_DPH_DASHBOARD_LIST_URL = "/api/0.1/fetch/dph/dashboard/data";

export const GET_DPH_BRANCHES_LIST_URL = "/api/0.1/fetch/dph/related/branches";

export const POST_DPH_SEND_TO_APPROVAL_URL = "/api/0.1/write/dph/dashboard/send/approval";

export const GET_DPH_RFQ_DETAILS_URL = "/api/0.1/fetch/dph/rfq/details";

export const POST_DPH_APPROVE_REJECT_PROPOSAL_URL = "/api/0.1/write/dph/dashboard/approve/reject/proposal";

export const POST_UPDATE_BUSINESS_VOLUME_URL = "/api/0.1/update/business/volume";

export const GET_DPH_APPROVER_DETAILS_URL = "/api/0.1/fetch/approver";

export const GET_DPH_DOWNLOAD_EXCEL_URL = "/api/0.1/download/dph/revised/price/excel";

export const ADMIN_UPDATE_RFQ_URL = '/api/0.1/write/admin/rfq/update';



/* Transportation Management End Here */

/*side menu*/
export const GET_SIDEBAR_CONFIG_URL = '/admin/api/0.1/fetch/master/config';
export const GET_DAAI_INTEGRATION_CONFIG_URL='/admin/api/0.1/get/fetchcompanydata';
export const FETCH_COMPANY_DATA_URL = '/indent/api/0.1/get/fetchcompanydata';

export const GET_TERMS_AND_CONDITIONS_URL = '/api/v1/fetch/TeramsAndConditions';

const jsonToUrlParams = (json) => {
   return Object.keys(json).map(function (k) {
      if (typeof json[k] != 'undefined' && json[k] !== '') {
         return encodeURIComponent(k) + '=' + encodeURIComponent(json[k])
      }
      return "";
   }).filter((item) => {
      return item;
   }).join('&')
}

export const postDataWithoutToken = (url, data) => {
   return new Promise((resolve, reject) => {
      fetch(`${baseUrl}${url}`, {
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
         },
         method: 'POST',
         body: JSON.stringify(data)
      }).then((response) => {
         if (response.status === 401) {
            logOutWithToken();
            // deleteToken();
            // location.href = "/";
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};

export const getDataWithoutToken = (url, params = {}) => {
   return new Promise((resolve, reject) => {
      fetch(`${baseUrl}${url}?${jsonToUrlParams(params)}`, {
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
         },
         method: 'GET',
         // body: JSON.stringify(data)
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);

         reject(e);
      });
   });
};

export const getDataWithToken = (url, params = {}) => {
   return new Promise((resolve, reject) => {
      fetch(`${baseUrl}${url}?${jsonToUrlParams(params)}`, {
         headers: { token: getToken() }
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);

         reject(e);
      });
   });
};
export const getIndentingDataWithToken = (url, params = {}) => {
   return new Promise((resolve, reject) => {
      fetch(`${INDENTING_BASE_URL}${url}?${jsonToUrlParams(params)}`, {
         headers: { token: getToken() }
      }).then((response) => {
         if (response.status === 401) {
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);

         reject(e);
      });
   });
};
export const deleteDataWithToken = (url, params = {}, data, domainUrl = '') => {
   return new Promise((resolve, reject) => {
      fetch(`${domainUrl ? domainUrl : baseUrl}${url}?${jsonToUrlParams(params)}`, {
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            token: getToken()
         },
         method: 'DELETE',
         body: JSON.stringify(data)
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);

         reject(e);
      });
   });
};

export const putDataWithToken = (url, data, domainUrl = '') => {
   return new Promise((resolve, reject) => {
      fetch(`${domainUrl ? domainUrl : baseUrl}${url}`, {
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            token: getToken()
         },
         method: 'PUT',
         body: JSON.stringify(data)
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};

export const getLCLDataWithToken = (url, params = {}) => {
   return new Promise((resolve, reject) => {
      fetch(`${LCL_BASE_URL}${url}?${jsonToUrlParams(params)}`, {
         headers: { token: getToken() }
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);

         reject(e);
      });
   });
};

export const putLCLDataWithToken = (url, data) => {
   return new Promise((resolve, reject) => {
      fetch(`${LCL_BASE_URL}${url}`, {
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            token: getToken()
         },
         method: 'PUT',
         body: JSON.stringify(data)
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};

export const postDataWithToken = (url, data, params={}, domainUrl) => {
   return new Promise((resolve, reject) => {
      fetch(`${domainUrl ? domainUrl : baseUrl}${url}?${jsonToUrlParams(params)}`, {
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            token: getToken()
         },
         method: 'POST',
         body: JSON.stringify(data)
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};

export const ssoPostDataWithToken = (url, params={}, genericToken=null) => {
   return new Promise((resolve, reject) => {
      fetch(`${SSO_BASE_URL}${url}?${jsonToUrlParams(params)}`, {
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            token: genericToken || getToken()
         },
         method: 'POST'
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};

export const uploadFile = (url, file, params = {}, domainUrl = '') => {
   let form = new FormData();
   form.append("file", file);
   Object.keys(params).forEach((key) => {
      form.append([key], params[key])
   });
   return new Promise((resolve, reject) => {
      fetch(`${domainUrl ? domainUrl : baseUrl}${url}`, {
         headers: {
            'Accept': 'application/json',
            token: getToken()
         },
         method: 'POST',
         body: form,
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            });
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};

export const uploadUPFile = (url, file, params = {}) => {
   let form = new FormData();
   form.append("file", file);
   // Object.keys(params).forEach((key) => {
   //    form.append([key], params[key])
   // });
   return new Promise((resolve, reject) => {
      fetch(`${baseUrl}${url}?${jsonToUrlParams(params)}`, {
         headers: {
            'Accept': 'application/json',
            token: getToken()
         },
         method: 'POST',
         body: form,
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            });
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};

// ************* POST call for LPP details only ************* //
export const postLPPDataWithoutToken = (url, data) => {
   return new Promise((resolve, reject) => {
      fetch(`${LPP_BASE_URL}${url}`, {
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
         },
         method: 'POST',
         body: JSON.stringify(data)
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};
// ********************************************************** //


// ************* POST call for File uploads only ************* //
export const uploadFileWithSyncCalls = (url, file, params = {}) => {
   let form = new FormData();
   form.append("file", file);
   Object.keys(params).forEach((key) => {
      form.append([key], params[key])
   });
   return new Promise((resolve, reject) => {
      fetch(`${baseUrl}${url || FILE_UPLOAD_POST_API_URL}`, {
         headers: {
            'Accept': 'application/json',
            token: getToken()
         },
         method: 'POST',
         body: form,
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            });
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};
// ********************************************************** //




// ************* GET call for LPP details only ************* //
export const getLPPDataWithoutToken = (url, data) => {
   return new Promise((resolve, reject) => {
      fetch(`${CP_LPP_BASE_URL}${url}?${jsonToUrlParams(params)}`, {
         headers: { token: getToken() }
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);

         reject(e);
      });
   });
};
// ********************************************************** //


// ****************** Accept/Reject URL ******************** //
export const putDataWithTokenToIndents = (url, data) => {
   return new Promise((resolve, reject) => {
      fetch(`${acceptRejectURL}${url}`, {
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            token: getToken()
         },
         method: 'PUT',
         body: JSON.stringify(data)
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};
// ********************************************************** //


export const getIPAdress = (url) => {
   return new Promise((resolve, reject) => {
      fetch(GET_IP_ADDRESS_URL, {
         headers: {
            // 'Accept': 'application/json',
            // 'Content-Type': 'application/json'
         },
         method: 'GET',
         // body: JSON.stringify(data)
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            localStorage.setItem('IPAddress', data.ip);
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);

         reject(e);
      });
   });
};

/**** WEB NOTIFICATION ******/
export const getDataForNotifWithToken = (url, params = {}) => {
   return new Promise((resolve, reject) => {
      fetch(`${baseUrl}${WEB_NOTIFICATION_URL}?${jsonToUrlParams(params)}`, {
         headers: { token: getToken() }
      }).then((response) => {
         if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            const resultData = data.data; 
            if(window.Notification.permission === 'granted' && resultData) {
               if(resultData.rfq_count > 0 || resultData.bid_end_count > 0) {

                  let body = '';

                  if(resultData.rfq_count > 0 && resultData.bid_end_count > 0) {
                     body = resultData.msg + "/n" + resultData.bid_end_msg
                  } else if(resultData.rfq_count > 0) {
                     body = resultData.msg;
                  } else if(resultData.bid_end_count > 0) {
                     body = resultData.bid_end_msg;
                  }
                  var notification = new Notification('New Message', {
                    body,
                    icon: './icons/logo@3x.png',
                  })
                  notification.onclick = () => {
                     notification.close();
                     window.parent.focus();
                  }   
               }
               setTimeout(() => {
                  if(document.visibilityState === 'hidden') {
                     getDataForNotifWithToken(WEB_NOTIFICATION_URL, params);
                  }
               }, 60000);
            }
         });
      }).catch((e) => {
         console.log('ERROR', e);

         reject(e);
      });
   });
};

/**** SYSTEM SUGGESTED PRICE  ****/

export const getDataSSPWithToken = (url, params = {}) => {
   return new Promise((resolve, reject) => {
      fetch(`${baseUrl}${url}?${jsonToUrlParams(params)}`, {
         headers: { 
            token: getToken(),
            ['customer-id']: getUser().companyId
         }
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);

         reject(e);
      });
   });
};


/**** GET CSV TEMPLATE ****/
export const getCSVDataWithToken = (url, params={})=> {
    return new Promise((resolve, reject)=> {
        let fetchUrl = `${accountsBaseUrl}${url}`;
        if (Object.keys(params).length > 0) {
            fetchUrl += `?${jsonToUrlParams(params)}`;
        } else if (typeof params === 'number' || typeof params === 'string') {
            fetchUrl += params + '/';
        }
        fetch(fetchUrl, {
            method: 'GET',
            headers: {
              "Content-type": "application/json; charset=UTF-8",
              token:getToken(),
              'customer-id': getUser().companyId,
            },
        }).then((response)=> {
            if(response && response.status >= 400) {
                response.json().then((data)=>{
                    reject(data);
                })
                return;
            }
            response.text().then((data)=>{
                resolve(data);
            });
        }).catch((e)=> {
            console.log('ERROR', e);

            reject(e);
        });
    });
};


/**** REPORT FILE UPLOAD API ****/
export const reportUploadFile = (url, file, params = {}, bodyData)=>{
   let form = new FormData();
   if (file) {
      form.append("uploaded_file", file);
   }
   if (Object.keys(bodyData).length > 0) {
      if ((bodyData.from || []).length > 0) {
         form.append("from", bodyData.from);
      }
      if ((bodyData.to || []).length > 0) {
         form.append("to", bodyData.to);
      }
   }

   return new Promise((resolve, reject) => {
      fetch(`${accountsBaseUrl}${url}?${jsonToUrlParams(params)}`, {
         headers: {
            'Accept': 'application/json',
            token: getToken(),
            'customer-id': getUser().companyId,
         },
         method: 'POST',
         body: form,
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            });
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });

};

/********* ACCOUNTS GET **********/
export const getAccountsDataWithToken = (url, params = {}) => {
   return new Promise((resolve, reject) => {
      fetch(`${accountsBaseUrl}${url}?${jsonToUrlParams(params)}`, {
         headers: { token: getToken(), 'customer-id': getUser().companyId, }
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);

         reject(e);
      });
   });
};

/********* LOGOUT  **********/
export const logOutWithToken = () => {
   return new Promise((resolve, reject) => {
      fetch(`${SSO_BASE_URL}${LOG_OUT_URL}`, {
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            token: getToken(),
            module: 1
         },
         method: 'POST',
         body: JSON.stringify({"module_id": 1})
      }).then((response) => {
         if (response.status === 401) {
            deleteToken();
            location.href = "/";
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               deleteToken();
               // reject(data);
            })
            return;
         }
         response.json().then((data) => {
            deleteToken();
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};

// ADMIN URL

export const getAdminDataWithToken = (url, params={})=> {
   return new Promise((resolve, reject)=> {
       fetch(`${adminBaseUrl}${url}?${jsonToUrlParams(params)}`, {
           headers:{token:getToken()}
       }).then((response)=> {
           if(response.status === 401) {
               logOutWithToken();
               // deleteToken();
               // location.href="/";
           }
           else if(response.status >= 400) {
               response.json().then((data)=>{
                   reject(data);
               })
               return;
           }
           response.json().then((data)=>{
               resolve(data);
           });
       }).catch((e)=> {
           console.log('ERROR', e);

           reject(e);
       });
   });
}; 

export const ssoGetDataWithToken = (url, params = {}, genericToken=null) => {
   return new Promise((resolve, reject) => {
      fetch(`${SSO_BASE_URL}${url}?${jsonToUrlParams(params)}`, {
         headers: { 
            token: genericToken || getToken() 
         }
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            // logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);

         reject(e);
      });
   });
};

export const ssoGetTegUserData = (url, token, module) => {
   return new Promise((resolve, reject) => {
      fetch(`${SSO_BASE_URL}${url}`, {
         headers: {
            token,
            module,
         }
      }).then((response) => {
         if (response.status >= 400) {
            response.json().then((data) => { reject(data); });
            return;
         }
         response.json().then((data) => { resolve(data); });
      }).catch((e) => {
         reject(e);
      });
   });
};

export const ssoPostDataWithoutToken = (url, data) => {
   return new Promise((resolve, reject) => {
      fetch(`${SSO_BASE_URL}${url}`, {
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
         },
         method: 'POST',
         body: JSON.stringify(data)
      }).then((response) => {
         if (response.status === 401) {
            if(location.pathname === '/') {
               response.json().then((data) => {
                  reject(data);
               })
               return;
            } else {
               logOutWithToken();
            }
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};

export const postSSODelete = (url, params={}) => {
   return new Promise((resolve, reject) => {
      fetch(`${SSO_BASE_URL}${url}?${jsonToUrlParams(params)}`, {
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            token: getToken()
         },
         method: 'POST'
      }).then((response) => {
         if (response.status === 401) {
            // deleteToken();
            // location.href = "/";
            logOutWithToken();
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};

export const putFileWithToken = (url, file, params = {}, domainUrl = '') => {
   let form = new FormData();
   if (file) form.append('file', file);
   Object.keys(params).forEach(key => form.append(key, params[key]));
   return new Promise((resolve, reject) => {
      fetch(`${domainUrl ? domainUrl : baseUrl}${url}`, {
         headers: { Accept: 'application/json', token: getToken() },
         method: 'PUT',
         body: form,
      }).then((response) => {
         if (response.status === 401) {
            logOutWithToken();
            return;
         }
         if (response.status >= 400) {
            response.json().then((data) => reject(data));
            return;
         }
         response.json().then((data) => resolve(data));
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};

export const downloadFileWithToken = (url, params = {}, filename = 'download') => {
   return new Promise((resolve, reject) => {
      let fetchUrl = `${baseUrl}${url}`;
      if (Object.keys(params).length > 0) {
         const qs = Object.keys(params)
            .filter(k => params[k] !== undefined && params[k] !== null && params[k] !== '')
            .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
            .join('&');
         if (qs) fetchUrl += `?${qs}`;
      }
      fetch(fetchUrl, {
         method: 'GET',
         headers: { token: getToken() },
      }).then((response) => {
         if (response.status === 401) {
            logOutWithToken();
            return;
         }
         if (response.status >= 400) {
            response.json().then((data) => reject(data));
            return;
         }
         response.blob().then((blob) => {
            const objectUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = objectUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(objectUrl);
            resolve();
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};

export const ssoPostDataWithTokenForResetOrChangePassword = (url, data, genericToken=null) => {
   return new Promise((resolve, reject) => {
      fetch(`${SSO_BASE_URL}${url}`, {
         headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'token': genericToken || getToken()
         },
         method: 'POST',
         body: JSON.stringify(data)
      }).then((response) => {
         if (response.status === 401) {
            if(location.pathname === '/') {
               response.json().then((data) => {
                  reject(data);
               })
               return;
            } else {
               logOutWithToken();
            }
         }
         else if (response.status >= 400) {
            response.json().then((data) => {
               reject(data);
            })
            return;
         }
         response.json().then((data) => {
            resolve(data);
         });
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};

/**** PINCODE VALIDATION (India Post) ****/

export const POSTAL_PINCODE_API_URL = 'https://api.postalpincode.in/pincode/';

export const validatePincodeWithPostalApi = (pincode) => {
   return new Promise((resolve, reject) => {
      fetch(`${POSTAL_PINCODE_API_URL}${pincode}`).then((response) => {
         return response.json();
      }).then((data) => {
         resolve(((data || [])[0] || {}).Status === 'Success');
      }).catch((e) => {
         console.log('ERROR', e);
         reject(e);
      });
   });
};
